

import React from "react";

export const Star011 = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.43035 1.68378C8.15811 1.55398 7.84184 1.55398 7.5696 1.68378C7.33426 1.79599 7.2045 1.99081 7.13906 2.09769C7.07142 2.20818 7.00197 2.34894 6.93429 2.48613L5.49713 5.39765L2.28243 5.86753C2.13111 5.88961 1.97583 5.91228 1.84989 5.94256C1.72805 5.97186 1.50278 6.03523 1.3235 6.22445C1.11611 6.44337 1.01857 6.74418 1.05805 7.04313C1.09218 7.30155 1.23741 7.48505 1.31888 7.58027C1.40309 7.6787 1.51552 7.78817 1.6251 7.89485L3.95029 10.1596L3.40165 13.3584C3.37575 13.5093 3.34918 13.664 3.33895 13.7932C3.32906 13.9181 3.3195 14.1521 3.44396 14.3812C3.58793 14.6463 3.84385 14.8322 4.14043 14.8871C4.39684 14.9347 4.61636 14.8533 4.73211 14.8052C4.85181 14.7556 4.99076 14.6825 5.1262 14.6112L7.99997 13.0999L10.8738 14.6112C11.0092 14.6825 11.1481 14.7556 11.2678 14.8052C11.3836 14.8533 11.6031 14.9347 11.8595 14.8871C12.1561 14.8322 12.412 14.6463 12.556 14.3812C12.6805 14.1521 12.6709 13.9181 12.661 13.7932C12.6508 13.664 12.6242 13.5093 12.5983 13.3585L12.0497 10.1596L14.3749 7.89482C14.4844 7.78815 14.5969 7.67869 14.6811 7.58027C14.7625 7.48505 14.9078 7.30155 14.9419 7.04313C14.9814 6.74418 14.8838 6.44337 14.6764 6.22445C14.4972 6.03523 14.2719 5.97186 14.1501 5.94256C14.0241 5.91228 13.8688 5.88961 13.7175 5.86753L10.5028 5.39765L9.06569 2.48618C8.998 2.34898 8.92854 2.20819 8.86089 2.09769C8.79545 1.99081 8.66569 1.79599 8.43035 1.68378Z"
        fill="#FFAA00"
      />
    </svg>
  );
};
